import { createApp } from 'vue'
import App from './App.vue'
// import store from './store/index'

import '../style.css'
import router from './router'

createApp(App).use(router).mount('#app')